export enum OpenBillsTestIdEnum {
	BTN_VISUALIZAR_BOLETOS_PAGOS = 'btn_visualizar_boletos_pagos',
	BTN_VER_DETALHES_BOLETO = 'btn_ver_detalhes_boleto',
	BTN_VER_DETALHES_BOLETO_SAO_LUCAS = 'btn_ver_detalhes_boleto_sao_lucas',
	BTN_COPIAR_CODIGO_BOLETO = 'btn_copiar_codigo_boleto',
	BTN_COPIAR_CODIGO_BOLETO_SAO_LUCAS = 'btn_copiar_codigo_boleto_sao_lucas',
	BTN_BAIXAR_PDF_BOLETO = 'btn_baixar_pdf_boleto',
	BTN_BAIXAR_PDF_BOLETO_SAO_LUCAS = 'btn_baixar_pdf_boleto_sao_lucas',
	BTN_COPIAR_CODIGO_BOLETO_DETALHES = 'btn_copiar_codigo_boleto_detalhes',
	BTN_COPIAR_CODIGO_BOLETO_DETALHES_SAO_LUCAS = 'btn_copiar_codigo_boleto_detalhes_sao_lucas',
	BTN_MODAL_IR_PARA_BOLETO_MAIS_ANTIGO = 'btn_modal_ir_para_boleto_mais_antigo',
	BTN_MODAL_ACAO_BOLETO_ATUAL = 'btn_modal_acao_boleto_atual',
}
